import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=4dcc8b0d&scoped=true&lang=pug&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"
import style0 from "./Message.vue?vue&type=style&index=0&id=4dcc8b0d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcc8b0d",
  null
  
)

export default component.exports